import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center font-montserrat items-center" }
const _hoisted_2 = { class: "container max-w-[1024px]" }
const _hoisted_3 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[10px]" }
const _hoisted_4 = { class: "container max-w-[1024px] relative w-full my-[50px]" }
const _hoisted_5 = { class: "w-full p-[10px] relative md:flex" }
const _hoisted_6 = { class: "relative w-full text-3xl text-left flex" }
const _hoisted_7 = { class: "text-blue-800 mb-[10px]" }
const _hoisted_8 = { class: "md:text-left text-center" }
const _hoisted_9 = { class: "w-full overflow-hidden max-h-[300px] relative p-[10px]" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "w-full relative p-[10px] overflow-x-hidden max-w-screen h-auto" }
const _hoisted_12 = ["innerHTML"]

import HeaderComponent from '../components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axiosInstance from '@/plugins/axios';
interface NewsDetail {
  id: number;
  title: string;
  content: string;
  image: string;
  date: string;
}


interface Comment {
  username: string;
  content: string;
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsDetail',
  setup(__props) {

let isSuperUser = ref(false);

const router = useRouter();

const newsDetailId = router.currentRoute.value.params.id;

const newsDetail = ref<NewsDetail>({
  id: 0,
  title: '',
  content: '',
  image: '',
  date: '',
});


function extractTextFromHTML(html: any) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.innerText || "";
}

const textWithoutHTML = extractTextFromHTML(newsDetail.value.content);


const loadNewsDetails = async (id: any) => {
  try {
    const response = await axiosInstance.get(`/news/${id}/`);
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { title, author, content, image, date, source, is_published, comments, likes, is_liked_by_current_user } = response.data;
      newsDetail.value = {
        id,
        title,
        content,
        image,
        date,
      };
    }
  } catch (error) {
    console.error('Erreur lors du chargement des détails du news', error);
  }
};



const pageTitle = ref('IronSecur | Nom news');
const id = ref(''); 
onMounted(() => {
  const newsDetailId = router.currentRoute.value.params.id;
  id.value = newsDetailId;
  loadNewsDetails(newsDetailId);
});

const Like = async () => {
  try {

    await axiosInstance.post(`/news/${newsDetailId}/likes/`);

    await loadNewsDetails(newsDetailId);

  } catch (error) {
    console.error('Error toggling like:', error);
  }
};

const latestComment = ref<Comment | null>(null);

let user = ref({});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    user.value = response.data;
    isSuperUser.value = response.data.is_staff;
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchUserProfile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(newsDetail.value.title), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: newsDetail.value.image,
              alt: "",
              class: "w-full max-h-[400px]"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              innerHTML: newsDetail.value.content,
              class: "max-w-screen ql-editor h-auto"
            }, null, 8, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})